module.exports = __webpack_public_path__ + "static/media/Risorsa 017.9a0d728b.svg";